const userStateReducer = (state = {}, action) => {
  switch (action.type) {
    case 'SET_USERSTATE': {
      return action.payload
    }
    default:
      return state
  }
}
export default userStateReducer